var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"className":"fill-current","src":require("@/assets/images/temporary/111.svg")}})])
}]

export { render, staticRenderFns }